import React from 'react';
import { useTranslation } from 'react-i18next';
import { Download, ArrowRight, Check, MapPin } from 'lucide-react';
import { Button } from './ui/button';

const HowItWorksSection = () => {
  const { t } = useTranslation();

  const steps = [
    { step: 1, titleKey: 'landing.step1Title', descKey: 'landing.step1Desc', icon: Download },
    { step: 2, titleKey: 'landing.step2Title', descKey: 'landing.step2Desc', icon: MapPin },
    { step: 3, titleKey: 'landing.step3Title', descKey: 'landing.step3Desc', icon: Check },
  ];
  
  return (
    <section id="how-it-works" className="py-24 bg-[#0a0a0a] relative overflow-hidden">
      {/* Background elements */}
      <div className="absolute inset-0 bg-[linear-gradient(rgba(255,255,255,0.02)_1px,transparent_1px),linear-gradient(90deg,rgba(255,255,255,0.02)_1px,transparent_1px)] bg-[size:60px_60px]" />
      
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-4">
            {t('landing.howItWorks')}
          </h2>
          <p className="text-gray-400 text-lg max-w-2xl mx-auto">
            {t('landing.bookingEasy')}
          </p>
        </div>

        {/* Steps */}
        <div className="grid md:grid-cols-3 gap-8 mb-16">
          {steps.map((step, index) => {
            const IconComponent = step.icon;
            return (
              <div
                key={step.step}
                className="relative group"
              >
                {/* Connector line */}
                {index < steps.length - 1 && (
                  <div className="hidden md:block absolute top-16 left-1/2 w-full h-0.5 bg-gradient-to-r from-amber-500/50 to-transparent" />
                )}

                <div className="bg-gradient-to-br from-white/5 to-transparent border border-white/10 rounded-2xl p-8 text-center transition-all duration-500 hover:border-amber-500/50 hover:-translate-y-2">
                  {/* Step number */}
                  <div className="w-16 h-16 bg-amber-500 rounded-full flex items-center justify-center mx-auto mb-6 text-black font-bold text-2xl group-hover:scale-110 transition-transform">
                    {step.step}
                  </div>

                  {/* Icon */}
                  <div className="w-20 h-20 bg-amber-500/10 rounded-full flex items-center justify-center mx-auto mb-6">
                    <IconComponent className="w-10 h-10 text-amber-500" />
                  </div>

                  {/* Title */}
                  <h3 className="text-xl font-semibold text-white mb-4">
                    {t(step.titleKey)}
                  </h3>
                  <p className="text-gray-400 mb-6">
                    {t(step.descKey)}
                  </p>
                </div>
              </div>
            );
          })}
        </div>

        {/* App download reminder */}
        <div className="text-center">
          <p className="text-gray-400 mb-4">{t('landing.readyToStart')}</p>
        </div>
      </div>
    </section>
  );
};

export default HowItWorksSection;
